import React, { FC, useState } from 'react';

import { StyledAvatar, StyledAvatarImage } from './styled';

interface RecipientAvatarProps {
  seed: string;
  name: string;
  src?: string | null;
  size?: number;
}

const getInitials = (name: string) => {
  const parts = name
    .replace(/@.*/, '')
    .split(/[\s._-]+/)
    .filter(Boolean);
  return (
    (parts[0]?.[0] || '') + (parts.length > 1 ? parts[1][0] : '')
  ).toUpperCase();
};

const RecipientAvatar: FC<RecipientAvatarProps> = ({
  seed,
  name,
  src,
  size = 24,
}) => {
  const [failed, setFailed] = useState(false);

  return (
    <StyledAvatar seed={seed} size={size} aria-hidden="true">
      {src && !failed ? (
        <StyledAvatarImage src={src} alt="" onError={() => setFailed(true)} />
      ) : (
        getInitials(name) || '?'
      )}
    </StyledAvatar>
  );
};

export default RecipientAvatar;
